import { BaseElement } from "../../lib/base-element.js";
import offerBoxStyles from "../../lib/offer-box-styles.js";
import { OfferPaymentMixin } from "../../lib/mixin/offer-payment-mixin.js";
import { html, css } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
import { repeat } from "lit/directives/repeat.js";
import { apiHost, formatCurrency } from "../../lib/utils.js";
import { classMap } from "lit/directives/class-map.js";
import axios from "axios";
import { SelectedState } from "../../lib/selected-state.js";
import { styleMap } from "lit/directives/style-map.js";
import "../season-interruption/season-interruption.js";
import "../gap-medical/gap-medical.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let CombinationOffer = class extends OfferPaymentMixin(BaseElement) {
  constructor() {
    super(...arguments);
    this.customerCountry = "US";
    this.tabs = [];
    this.currentTabIndex = 0;
    this.currentProductViewIndex = [];
    this.quotes = {};
    this.isMobile = false;
  }
  async connectedCallback() {
    const mediaQueryElement = window.matchMedia("(max-width: 768px)");
    mediaQueryElement.addEventListener("change", () => {
      this.isMobile = mediaQueryElement.matches;
    });
    if (this.offerId == void 0) {
      const response = await axios.get(`${apiHost}/v1/products/gap-medical`, {
        headers: {
          "Content-Type": "application/json",
          "x-api-client-id": this.clientId,
          "x-api-source": "Web Component",
          "x-api-web-component-version": "4.14.0"
        }
      });
      this.offerId = response.data.offer_id;
    }
    super.connectedCallback();
  }
  /**
   * @ignore
   */
  handleSlotchange() {
    var _a;
    const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("slot");
    const combinationOfferOptions = slot == null ? void 0 : slot.assignedElements({ flatten: true });
    this.currentProductViewIndex = Array(combinationOfferOptions == null ? void 0 : combinationOfferOptions.length).fill(0);
    const updatedTabs = [];
    for (const option of combinationOfferOptions) {
      const el = option;
      el.addEventListener("offer-state-change", (e) => {
        e.stopPropagation();
        const quoteUpdates = { ...this.quotes };
        const quoteId = e.detail.quote.quote_id;
        quoteUpdates[quoteId] = quoteId in quoteUpdates ? { ...quoteUpdates[quoteId], quote: e.detail.quote } : { quote: e.detail.quote, selectedState: SelectedState[SelectedState.UNKNOWN] };
        this.quotes = quoteUpdates;
        this.requestUpdate();
      });
      el._offerId = this.offerId;
      el.clientId = this.clientId;
      el.customerFirstName = this.customerFirstName;
      el.customerLastName = this.customerLastName;
      el.customerEmailAddress = this.customerEmailAddress;
      el.customerCountry = this.customerCountry;
      el.customerState = this.customerState;
      el.customerPostalCode = this.customerPostalCode;
      el.customerStreetAddress = this.customerStreetAddress;
      el.dataset.uniqueId = updatedTabs.length.toString();
      updatedTabs.push({
        label: `${el.participantFirstName} ${el.participantLastName}`,
        context: el.coverageContextDescription ?? void 0
      });
    }
    this.tabs = updatedTabs;
  }
  /**
   * @ignore
   */
  get offerId() {
    return localStorage.getItem(this.offerIdStorageKey);
  }
  /**
   * @ignore
   */
  set offerId(offerId) {
    if (offerId) localStorage.setItem(this.offerIdStorageKey, offerId);
  }
  /**
   * @ignore
   */
  unsetOfferId() {
    localStorage.removeItem(this.offerIdStorageKey);
  }
  /**
   * @ignore
   */
  get offerIdStorageKey() {
    return `_vi_offer_id:combination`;
  }
  /**
   * @ignore
   */
  _declineQuotes(...quoteIds) {
    const quoteUpdates = { ...this.quotes };
    for (const quoteId of quoteIds) {
      if (quoteId in quoteUpdates) {
        quoteUpdates[quoteId].selectedState = SelectedState[SelectedState.DECLINED];
      }
    }
    this.quotes = quoteUpdates;
  }
  /**
   * @ignore
   */
  _unselectQuotes(...quoteIds) {
    const quoteUpdates = { ...this.quotes };
    for (const quoteId of quoteIds) {
      if (quoteId in quoteUpdates) {
        quoteUpdates[quoteId].selectedState = SelectedState[SelectedState.UNKNOWN];
      }
    }
    this.quotes = quoteUpdates;
  }
  /**
   * @ignore
   */
  _quotesDeclined(...quoteIds) {
    for (const quoteId of quoteIds) {
      if (this.quotes[quoteId].selectedState !== SelectedState[SelectedState.DECLINED]) {
        return false;
      }
    }
    return true;
  }
  /**
   * @ignore
   */
  _selectSingleQuote(quoteId) {
    const quoteUpdates = { ...this.quotes };
    quoteUpdates[quoteId].selectedState = SelectedState[SelectedState.ACCEPTED];
    this.quotes = quoteUpdates;
  }
  /**
   * @ignore
   */
  _selectQuotes(...quoteIds) {
    const quoteUpdates = { ...this.quotes };
    for (const quoteId of quoteIds) {
      if (quoteId in quoteUpdates) {
        quoteUpdates[quoteId].selectedState = SelectedState[SelectedState.ACCEPTED];
      }
    }
    this.quotes = quoteUpdates;
  }
  /**
   * @ignore
   */
  _triggerOfferStateChangeEvent() {
    const options = {
      detail: Object.values(this.quotes ?? []),
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent("offer-state-change", options));
    if (this.debug) {
      console.debug("Fired offer-state-change event", options.detail);
    }
  }
  async validate() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const currentErrors = /* @__PURE__ */ new Set();
    let isInsuranceValid = true;
    this.errors = [];
    const quoteDetailList = Object.values(this.quotes);
    for (const quoteDetails of quoteDetailList) {
      if (quoteDetails.selectedState === SelectedState[SelectedState.UNKNOWN]) {
        const firstName = ((_b = (_a = quoteDetails.quote.policy_attributes) == null ? void 0 : _a.participant) == null ? void 0 : _b.first_name) ?? ((_d = (_c = quoteDetails.quote.policy_attributes) == null ? void 0 : _c.covered_person) == null ? void 0 : _d.first_name);
        const lastName = ((_f = (_e = quoteDetails.quote.policy_attributes) == null ? void 0 : _e.participant) == null ? void 0 : _f.last_name) ?? ((_h = (_g = quoteDetails.quote.policy_attributes) == null ? void 0 : _g.covered_person) == null ? void 0 : _h.last_name);
        currentErrors.add(`A selection is required for ${firstName} ${lastName}`);
      }
    }
    if (currentErrors.size > 0) {
      isInsuranceValid = false;
    }
    this.errors = Array.from(currentErrors);
    return {
      isValid: isInsuranceValid,
      errors: this.errors
    };
  }
  render() {
    var _a, _b;
    const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("slot");
    const combinationOfferOptions = slot == null ? void 0 : slot.assignedElements({ flatten: true });
    return html`
      <slot @slotchange=${this.handleSlotchange}></slot>
      ${when(((_b = this.errors) == null ? void 0 : _b.length) > 0, () => html`
        <div class="error-list">
          <ul>
            ${repeat(this.errors, (_, i) => i, (error) => html`
              <li>${error}</li>
            `)}
          </ul>
        </div>
      `)}
      ${when(this.quotes && Object.keys(this.quotes).length > 0, () => html`
        <div role="tablist" class="tabs">
          ${repeat(this.tabs, (_, index) => index, (t, i) => {
      const combinationOfferOption = combinationOfferOptions[i];
      const seasonInterruptionQuote = combinationOfferOption._seasonInterruptionElement.quote;
      const gapMedicalQuote = combinationOfferOption._gapMedicalElement.quote;
      if (seasonInterruptionQuote || gapMedicalQuote) {
        return html`
                <label role="tab" class="tab" @click=${() => this.currentTabIndex = i}>
                  <div class="tab-name">${t.label}</div>
                  ${when(t.context, () => html`
                    <div class="tab-description">${t.context}</div>
                  `)}
                  <input type="radio" .checked=${i === this.currentTabIndex}  name="_tab_selector" />
                </label>
              `;
      }
    })}
        </div>

        ${repeat(this.tabs, (_, index) => index, (_, i) => {
      const combinationOfferOption = combinationOfferOptions[i];
      const seasonInterruptionElement = combinationOfferOption._seasonInterruptionElement;
      const gapMedicalElement = combinationOfferOption._gapMedicalElement;
      const quoteIds = [];
      if (seasonInterruptionElement.quote) {
        quoteIds.push(seasonInterruptionElement.quote.quote_id);
      }
      if (gapMedicalElement.quote) {
        quoteIds.push(gapMedicalElement.quote.quote_id);
      }
      return html`
            <div role="tabpanel" class="tab-content ${classMap({ "single-tab": this.tabs.length <= 1, "first-tab-selected": this.currentTabIndex == 0, "last-tab-selected": i == this.tabs.length - 1 && this.currentTabIndex == i })}" style=${styleMap({ display: this.currentTabIndex === i ? "flex" : "none" })}>
              ${this._renderTab(combinationOfferOption, quoteIds, i)}
              <div class="footer">
                <label class="decline-coverage" @click=${() => {
        this._declineQuotes(...quoteIds);
        this._triggerOfferStateChangeEvent();
      }}>
                  <input type="radio" .checked=${this._quotesDeclined(...quoteIds)} @click=${(e) => e.stopPropagation()}> Do not add coverage to my registration
                </label>
                <div class="footer-navigation">
                  ${when(this.tabs.length > 1, () => html`
                    <button @click=${() => this.currentTabIndex = this.currentTabIndex - 1} .disabled=${this.currentTabIndex <= 0} class="tab-navigation-button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left"><path d="m15 18-6-6 6-6"/></svg>
                      Back
                    </button>
                    <button @click=${() => this.currentTabIndex = this.currentTabIndex + 1} .disabled=${this.currentTabIndex >= this.tabs.length - 1} class="tab-navigation-button">
                      Next Participant
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
                    </button>
                  `)}
                </div>
              </div>
            </div>
          `;
    })}
      `)}
    `;
  }
  _renderTab(combinationOfferOption, quoteIds, tabIndex) {
    var _a, _b;
    const seasonInterruptionQuote = (_a = combinationOfferOption._seasonInterruptionElement) == null ? void 0 : _a.quote;
    const gapMedicalQuote = (_b = combinationOfferOption._gapMedicalElement) == null ? void 0 : _b.quote;
    if (gapMedicalQuote && seasonInterruptionQuote) {
      return html`
        <div class="carousel" id=${`carousel-${tabIndex}`}>
          ${this._renderCombinedOfferItem(combinationOfferOption, quoteIds, tabIndex)}
          ${this._renderOfferItem(seasonInterruptionQuote, tabIndex, 1, "Only Add Registration Protection", quoteIds)}
          ${this._renderOfferItem(gapMedicalQuote, tabIndex, 2, "Only Add Gap Medical Coverage", quoteIds)}
        </div>
      `;
    } else if (!seasonInterruptionQuote && gapMedicalQuote) {
      return html`<div class="center-offer">${this._renderOfferItem(gapMedicalQuote, tabIndex, 2, "Only Add Gap Medical Coverage", quoteIds)}</div>`;
    } else if (seasonInterruptionQuote && !gapMedicalQuote) {
      return html`<div class="center-offer">${this._renderOfferItem(seasonInterruptionQuote, tabIndex, 1, "Only Add Registration Protection", quoteIds)}</div>`;
    }
  }
  _renderCombinedOfferItem(combinationOfferOption, quoteIds, tabIndex) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    const seasonInterruptionElement = combinationOfferOption._seasonInterruptionElement;
    const seasonInterruptionTotal = ((_a = seasonInterruptionElement.quote) == null ? void 0 : _a.total) ?? 0;
    const seasonInterruptionDescriptors = ((_d = (_c = (_b = seasonInterruptionElement.quote) == null ? void 0 : _b.product) == null ? void 0 : _c.descriptors) == null ? void 0 : _d.slice(0, 2)) ?? [];
    const gapMedicalElement = combinationOfferOption._gapMedicalElement;
    const gapMedicalDescriptors = ((_g = (_f = (_e = gapMedicalElement.quote) == null ? void 0 : _e.product) == null ? void 0 : _f.descriptors) == null ? void 0 : _g.slice(0, 2)) ?? [];
    const gapMedicalTotal = ((_h = gapMedicalElement.quote) == null ? void 0 : _h.total) ?? 0;
    const combinationTotal = seasonInterruptionTotal + gapMedicalTotal;
    const gapMedicalSelected = ((_i = gapMedicalElement.quote) == null ? void 0 : _i.quote_id) && gapMedicalElement.quote.quote_id in this.quotes && this.quotes[gapMedicalElement.quote.quote_id].selectedState === SelectedState[SelectedState.ACCEPTED];
    const seasonInterruptionSelected = ((_j = seasonInterruptionElement.quote) == null ? void 0 : _j.quote_id) && seasonInterruptionElement.quote.quote_id in this.quotes && this.quotes[seasonInterruptionElement.quote.quote_id].selectedState === SelectedState[SelectedState.ACCEPTED];
    const completeCoverage = gapMedicalSelected && seasonInterruptionSelected || false;
    const combinationQuote = {
      product: {
        descriptors: [
          ...gapMedicalDescriptors,
          ...seasonInterruptionDescriptors
        ],
        friendly_name: "",
        legal_disclaimer: ""
      },
      total: combinationTotal
    };
    return html`
      <div class="carousel-item" id=${`vi-item-${tabIndex}-0`}>
        <div class="badge text-xs uppercase badge-spacer">Most Popular</div>
        <div class="header">
          <h4 class="text-lg">Add Registration Protection & Gap Medical Coverage</h4>
          <span class="text-xs text-muted">one-time fee of <b>${formatCurrency(combinationQuote.total, "USD")}</b></span>
        </div>
        <offer-add-button 
          @click=${() => {
      if (completeCoverage) {
        this._unselectQuotes(...quoteIds);
      } else {
        this._unselectQuotes(...quoteIds);
        this._selectQuotes(...quoteIds);
      }
      this._triggerOfferStateChangeEvent();
    }} 
          .addLabel=${"Add to Registration"}
          .removeLabel=${"Remove"}
          .selected=${completeCoverage}
        ></offer-add-button>
        <div>
          <h5>Registration Protection</h5>
          <div class="text-xs text-muted">one-time fee of <b>${formatCurrency(seasonInterruptionElement.total, "USD")}</b>, covers up to ${formatCurrency(combinationOfferOption.insurableAmount, "USD")}.</div>
          <div class="text-sm text-balance">${unsafeHTML(((_l = (_k = seasonInterruptionElement.quote) == null ? void 0 : _k.product) == null ? void 0 : _l.promotional_description) || "")}</div>
          <legal-disclaimer .quote=${seasonInterruptionElement.quote}></legal-disclaimer>
        </div>
        <div></div>
        <div class="">
          <h5>Gap Medical Coverage</h5>
          <div class="text-xs text-muted">one-time fee of <b>${formatCurrency(gapMedicalElement.total, "USD")}</b></div>
          <div class="text-sm text-balance">${unsafeHTML(((_n = (_m = gapMedicalElement.quote) == null ? void 0 : _m.product) == null ? void 0 : _n.promotional_description) || "")}</div>
          <legal-disclaimer .quote=${gapMedicalElement.quote}></legal-disclaimer>
        </div>
      </div>
    `;
  }
  /**
   * @ignore
   */
  _renderOfferItem(quote, tabIndex, itemIndex, title, quoteIds) {
    const completeCoverage = quoteIds.every((id) => this.quotes[id].selectedState === SelectedState[SelectedState.ACCEPTED]);
    if (quote) {
      return html`
        <div class="carousel-item ${classMap({ "disabled": completeCoverage && quoteIds.length > 1 })}" id=${`vi-item-${tabIndex}-${itemIndex}`}>
          <div class="badge-spacer text-xs uppercase"></div>
          <div class="header">
            <h4 class="text-lg">${title}</h4>
            <span class="text-xs text-muted">one-time fee of <b>${formatCurrency(quote.total, quote.currency)}</b></span>
          </div>
          <offer-add-button 
            .addLabel=${"Add to Registration"}
            .removeLabel=${"Remove"}
            @click=${() => {
        if (completeCoverage && quoteIds.length > 1) {
          this._unselectQuotes(...quoteIds);
        }
        if (this.quotes[quote.quote_id].selectedState === SelectedState[SelectedState.ACCEPTED]) {
          this._unselectQuotes(...quoteIds);
        } else {
          this._declineQuotes(...quoteIds);
          this._selectSingleQuote(quote.quote_id);
        }
        this._triggerOfferStateChangeEvent();
      }}
            .selected=${this.quotes[quote.quote_id].selectedState === SelectedState[SelectedState.ACCEPTED] && (!completeCoverage || quoteIds.length == 1)}
          ></offer-add-button>
          <descriptor-list .quote=${quote}></descriptor-list>
          <legal-disclaimer .quote=${quote}></legal-disclaimer>
        </div>
      `;
    }
  }
};
CombinationOffer.styles = [
  offerBoxStyles,
  css`
      :host {
        max-width: 1024px;
      }
      .tabs {
        width: 100%;
        display: flex;
        overflow: hidden;
        padding-right: 15px;
        position: relative;
        z-index: 9;
      }

      .tab {
        display: flex;
        gap: 4px;
        flex-direction: column;
        cursor: pointer;
        user-select: none;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-bottom: none;
        padding-top: calc(0.75rem + 1px);
        padding-left: calc(0.5rem + 1px);
        padding-right: calc(0.5rem + 1px);
        padding-bottom: 0.75rem;
        margin: 0;
        flex: 1;
        width: 100%;
        min-width: 25px;
        max-width: 250px;
        overflow:  hidden;
      }

      .tab div.tab-name {
        font-size: var(--default-vi-font-sm);
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .tab div.tab-description {
        font-size: var(--default-vi-font-xs);
        opacity: 0.8;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
      }

      .tab input[type=radio], .tab input[type=radio]:checked, .tab input[type=radio][aria-checked=true] {
        display: none;
      }

      .tab:has(input[type=radio]:checked) {
        border: 1px solid var(--default-vi-border-color);
        background-color: white;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-top-left-radius: var(--default-vi-border-radius);
        border-top-right-radius: var(--default-vi-border-radius);
        border-bottom: none;
        box-sizing: border-box;
        padding-top: 0.75rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        min-width: 140px;
      }

      .tab-content {
        background-color: white;
        margin-top: -1px;
        display: flex;
        border: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        padding: 0.75rem;
        box-sizing: border-box;
        gap: 8px;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
        min-width: 350px;
        gap: 8px;
        container-type: inline-size;
      } 

      .tab-content.single-tab {
        border-top-right-radius: 0;
      }

      .tab-content.first-tab-selected {
        border-top-left-radius: 0;
      }

      .carousel {
        display: flex;
        flex-direction: row;
        gap: 8px;
        justify-content: center;
      }

      .carousel-item {
        box-sizing: border-box;
        scroll-snap-align: center;
        display: flex;

        width: 33%;
        padding: 12px;
        border: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        background-color: var(--default-vi-neutral-color);
        max-width: 280px;
        min-width: 250px;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
      }

      .carousel-item.disabled {
        opacity: 0.5;
      }

      .center-offer .carousel-item {
        max-width: unset;
        width: 100%;
      }

      .center-offer .carousel-item offer-add-button {
        width: auto;
        min-width: 254px;
      }

      .carousel-menu {
        display: none;
        gap: 4px;
        border: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        padding: 4px;
      }

      .carousel-menu button {
        border: none;
        font-size: var(--default-vi-font-sm);
        border-radius: var(--default-vi-border-radius);
        background: transparent;
        padding: 8px 6px;
        font-weight: 400;
        flex: 1;
        text-align: center;
        display: block;
        white-space: nowrap;
        color: var(--default-vi-neutral-contrast-color);
      }

      .carousel-menu button.selected {
        background-color: var(--default-vi-primary-color);
        color: var(--default-vi-primary-contrast-color);
      }

      .footer {
        max-width: 856px;
        width: 100%;
        display: flex;
        margin: 0 auto;
      }

      .center-offer {
        max-width: 856px;
        width: 100%;
        display: flex;
        margin: 0 auto;
      }
      
      .footer-navigation {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
      }

      .decline-coverage {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
      }

      .tab-extended {
        background-color: white;
        border: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        padding: 4px;
        margin-bottom: 6px;
        align-items: center;
        position: relative;
        display: flex;
        margin-left: 6px;
      }
      
      .tab-extended svg {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        height: 16px;
        width: 16px;
      }

      .badge-spacer {
        height: 1.2lh;
      }

      .header h4 {
        height: 2lh;
      }

      .tab-navigation-button {
        border: var(--default-vi-tab-navigation-button-border);
        background: var(--default-vi-tab-navigation-button-background);
        color: var(--default-vi-tab-navigation-button-color);
      }

      .error-list {
        margin-bottom: 5px;
        border-radius: var(--default-vi-border-radius);
        border: 1px solid var(--default-vi-danger-border-color);
        background: var(--default-vi-danger-bg-color);
        color: var(--default-vi-danger-color);
      }

      @media only screen and (max-width: 768px) {
        .carousel-menu {
          display: flex;
        }

        .footer {
          flex-direction: column;
          gap: 20px;
        }

        .footer-navigation { 
          justify-content: center;
        }
      }

      @media only screen and (max-width: 920px) {
        .carousel {
          justify-content: left;
        }

        .footer {
          margin: unset;
        }
      }

      @container (max-width: 920px) {
        .carousel {
          justify-content: left;
        }

        .footer {
          margin: unset;
        }
      }

      @media only screen and (max-width: 830px) {
        .carousel {
          overflow-x: scroll;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          scrollbar-width: thin;
          padding-bottom: 8px;
        }

        .carousel-item {
          flex: none;
          width: 80%;
          min-width: unset;
        }
      }

      @container (max-width: 830px) {
        .carousel {
          overflow-x: scroll;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          scrollbar-width: thin;
          padding-bottom: 8px;
        }

        .carousel-item {
          flex: none;
          width: 80%;
          min-width: unset;
        }
      }

      @media only screen and (max-width: 640px) {
        .tab-content.last-tab-selected {
          border-top-right-radius: 0;
        }

        .tabs {
          padding-right: unset;
        }
      }
    `
];
__decorateClass([
  property({ attribute: "customer-first-name" })
], CombinationOffer.prototype, "customerFirstName", 2);
__decorateClass([
  property({ attribute: "customer-last-name" })
], CombinationOffer.prototype, "customerLastName", 2);
__decorateClass([
  property({ attribute: "customer-email-address" })
], CombinationOffer.prototype, "customerEmailAddress", 2);
__decorateClass([
  property({ attribute: "customer-street-address" })
], CombinationOffer.prototype, "customerStreetAddress", 2);
__decorateClass([
  property({ attribute: "customer-state" })
], CombinationOffer.prototype, "customerState", 2);
__decorateClass([
  property({ attribute: "customer-city" })
], CombinationOffer.prototype, "customerCity", 2);
__decorateClass([
  property({ attribute: "customer-postal-code" })
], CombinationOffer.prototype, "customerPostalCode", 2);
__decorateClass([
  property({ attribute: "customer-country" })
], CombinationOffer.prototype, "customerCountry", 2);
__decorateClass([
  state()
], CombinationOffer.prototype, "tabs", 2);
__decorateClass([
  state()
], CombinationOffer.prototype, "currentTabIndex", 2);
__decorateClass([
  state()
], CombinationOffer.prototype, "currentProductViewIndex", 2);
__decorateClass([
  state()
], CombinationOffer.prototype, "quotes", 2);
__decorateClass([
  state()
], CombinationOffer.prototype, "isMobile", 2);
CombinationOffer = __decorateClass([
  customElement("combination-offer")
], CombinationOffer);
export {
  CombinationOffer
};
